import { render } from "./CallToAction.vue?vue&type=template&id=3c3434f6&scoped=true"
import script from "./CallToAction.vue?vue&type=script&lang=js"
export * from "./CallToAction.vue?vue&type=script&lang=js"

import "./CallToAction.vue?vue&type=style&index=0&id=3c3434f6&scoped=true&lang=css"

import exportComponent from "/home/aungkhantkoko/Desktop/PortFolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c3434f6"]])

export default __exports__